import script from "./EmailTemplates.vue?vue&type=script&lang=ts&setup=true"
export * from "./EmailTemplates.vue?vue&type=script&lang=ts&setup=true"

import "./EmailTemplates.vue?vue&type=style&index=0&id=2fbdfbc2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fbdfbc2"]])

export default __exports__